module.exports = __webpack_public_path__ + "img/CustomerInfo.d925d942.svg";